export const GIF_MAX_PLAYABLE_BYTES = 10 * 1024 * 1024;

export function previewURL(
    autumnUrl: string,
    attachment: { tag: string; _id: string },
): string {
    return `${autumnUrl}/${attachment.tag}/preview/${attachment._id}`;
}

export function gifPlayable(attachment: {
    content_type?: string;
    size: number;
}): boolean {
    return (
        attachment.content_type === "image/gif" &&
        attachment.size <= GIF_MAX_PLAYABLE_BYTES
    );
}
